import React, { FC, useEffect } from 'react';
import MainLayout from '../main-layout/main-layout';
import { AEATabs, AEATab, ResumeProa, DetailsProa, Beneficiaries } from '../../components';
import { MainProaPresenter } from '@presenters/containers/main-proa.presenter';
const Proa: FC<any> = () => {

    const presenter = new MainProaPresenter();

    //useEffect(()=>{
    //    presenter.validateUserInfo();
    //},[presenter.currentUser])
    return (
        <MainLayout>
            <AEATabs defaultTab={0}>
                <AEATab title={presenter.currentLabels.get("ProaTab-Resumen")} active={true}>
                    <ResumeProa></ResumeProa>
                </AEATab>
                <AEATab title={presenter.currentLabels.get("ProaTab-Detalle")}>
                    <DetailsProa></DetailsProa>
                </AEATab>
                <AEATab title={presenter.currentLabels.get("BeneficiariosPais")}>
                    <Beneficiaries></Beneficiaries>
                </AEATab>
            </AEATabs>
        </MainLayout>);
}
export default Proa;
